import { RunFieldsConfiguration } from "../../field-type";


export const sumUpFileRunFieldsConfiguration: RunFieldsConfiguration = {

    runCursor: {
        visible: false
    },
    file: {
        visible: true,
        mimeType: "text/csv"
    }

}